export const COMMIT_HASH = '08935cf725a6d34eecf69074054de78b86abbd03';
